import MobileApp from './src/App'

export default MobileApp
